exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-tooltip{opacity:1!important;background-color:#f0f0f5!important;color:#828282!important}.img-icon{width:14px;height:14px}", ""]);

// exports
